<template>
  <v-container fluid class="user-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tabs-slider></v-tabs-slider>

          <v-tab :href="`#tab-projeto`" class="mr-5">
            <v-icon class="mr-3">mdi-briefcase-eye-outline</v-icon>
            Projeto
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-equipe`">
            <v-icon class="mr-3">mdi-account-group-outline</v-icon>
            Equipe
          </v-tab>
          
          <v-tab-item :value="'tab-projeto'">
            <ProjetoCard :isPermissao="isPermissao" :projeto="projeto"></ProjetoCard>
          </v-tab-item>
          
          <v-tab-item :value="'tab-equipe'">
            <v-row>
              <v-col cols="12" v-if="isPermissao">
                <v-card flat tile>
                  <v-card-text class="mx-auto">
                    <v-form
                      @submit.prevent="adicionarParticipante"
                      ref="formParticipante"
                      lazy-validation
                    >
                      <v-row class="mb-n8">
                        <v-col cols="12" md="5">
                          <v-autocomplete
                            :items="usuarios"
                            item-text="nome"
                            item-value="id"
                            v-model="usuario.id"
                            auto-select-first
                            filled
                            label="Usuários"
                            rows="1"
                            auto-grow
                            oninput="this.value = this.value.toUpperCase()"
                          >                          
                            <template v-slot:selection="data">
                                {{ data.item.nome }} - {{ data.item.organizacao.nome }}
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title v-html="data.item.nome"></v-list-item-title>
                                  <v-list-item-subtitle v-html="data.item.organizacao.nome"></v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="5">
                          <v-select
                            :items="papeis"
                            v-model="participante.papel"
                            filled
                            label="Papeis"
                            rows="1"
                            auto-grow
                            oninput="this.value = this.value.toUpperCase()"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="2" class="mt-2">
                          <v-btn type="submit" block large color="primary"
                            >Adicionar</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card flat tile>
                  <v-card-text class="pa-0 overflow-x-auto">
                    <v-data-table
                      :headers="headers"
                      :items="projeto.participantes"
                      sort-by="nome"
                      no-results-text="Nenhuma pessoa encontrada"
                      no-data-text="Não há participantes registradas"
                      :items-per-page="itemPerPage"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="(item, index) in items" :key="item.id">
                            <td>{{ item.usuario.nome }}</td>
                            <td>{{ item.usuario.email }}</td>
                            <td>{{ item.usuario.organizacao.nome }}</td>
                            <td>{{ item.papel }}</td>
                            <td>
                              <div class="text-right">
                                <v-btn
                                  v-if="isPermissao"
                                  class="mr-2"
                                  @click="excluirParticipante(item, index)"
                                  color="error text-center"
                                  small
                                  >Excluir</v-btn
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <Confirm ref="confirm"></Confirm>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import asyncDataStatus from "@/mixins/asyncDataStatus";
import ProjetoCard from "@/components/Projeto/ProjetoCard"
import Confirm from "@/components/Dialog/Confirm";

export default {
  components: {
    Confirm,
    ProjetoCard
  },
  data: () => ({
    dialog: false,
    participanteSelecionado: Object,
    items: [],
    headers: [
      {
        text: "Nome",
        align: "start",
        sortable: false,
        value: "usuario.nome",
      },
      { text: "Email", align: "start", value: "usuario.email" },
      { text: "Organização", align: "start", value: "usuario.organizacao.nome" },
      { text: "Papel", align: "start", value: "papel" },
      { text: "", align: "start", value: "acoes", sortable: false },
    ],
    itemPerPage: 10,
    participante: {},
    papeis: [
      { text: "Agente de Monitoramento Programático", value: "AGENTE_MONITORAMENTO_PROGRAMATICO" },
      { text: "Agente Lançador de Fontes", value: "AGENTE_LANCAMENTO_FONTES" },

      { text: "Agente de Monitoramento Financeiro", value: "AGENTE_MONITORAMENTO_FINANCEIRO" },
      { text: "Agente de Prestador de Contas", value: "AGENTE_PRESTACAO_CONTA" },
      { text: "Comissão de Prestação de Contas", value: "COMISSAO_PRESTACAO_CONTA" },

      { text: "Coordenador Institucional", value: "COORDENADOR_INSTITUCIONAL" },
      { text: "Financiador", value: "FINANCIADOR" },
    ],
    usuario: {},
  }),
  mixins: [asyncDataStatus],
  computed: {
    usuarios() {
      return this.$store.getters["usuario/all"];
    },
    projeto() {
      return this.$store.getters["projeto/getProjetoById"](
        parseInt(this.$route.params.projetoId)
      );
    },

    isPermissao() {
      //candEdit
      if(this.$store.getters["auth/isAdministrador"]) {
        return true
      }
      var payload = {
        'permission': ['PERMISSION_PROJETO_EDIT', 'PERMISSION_EQUIPE_EDIT'],
        'projetoId': parseInt(this.$route.params.projetoId),
        'usuarioId': this.$store.getters["usuario/getUsuarioAutenticado"].id,
      }
      
      return this.$store.getters["projeto/hasPermission"](payload);
    },
  },
  methods: {
    ...mapActions("usuario", ["fetchAllUsuarios"]),
    ...mapActions("projeto", ["addParticipante", "deletarParticipante"]),

    adicionarParticipante() {
      if (this.$refs.formParticipante.validate()) {
        const payload = {
          projetoId: this.$route.params.projetoId,
          participante: this.participante,
        };
        this.participante.usuario = this.usuarios.find(
          (p) => p.id === this.usuario.id
        );
        this.$store.dispatch("projeto/addParticipante", payload).then(() => {
          this.participanteFormReset();
        });
      }
    },
    
    excluirParticipante(item, index) {
      this.$refs.confirm
        .open("Excluir Participante", item.usuario.nome, "Você tem certeza?", {})
        .then((confirm) => {
          if (confirm) {
            const payload = {
              projetoId: this.$route.params.projetoId,
              participante: item,
              index: index,
            };
            return this.$store.dispatch("projeto/deletarParticipante", payload);
          }
        });
    },

    adicionarOrganizacao() {
      if (this.$refs.formParticipante.validate()) {
        const payload = {
          projetoId: this.$route.params.projetoId,
          participante: this.participante,
        };
        this.participante.usuario = this.usuarios.find(
          (p) => p.id === this.usuario.id
        );
        this.$store.dispatch("projeto/addParticipante", payload).then(() => {
          this.participanteFormReset();
        });
      }
    },
    
    excluirOrganizacao(item, index) {
      this.$refs.confirm
        .open("Excluir Organização", item.nome, "Você tem certeza?", {})
        .then((confirm) => {
          if (confirm) {
            const payload = {
              projetoId: this.$route.params.projetoId,
              participante: item,
              index: index,
            };
            return this.$store.dispatch("projeto/deletarParticipante", payload);
          }
        });
    },
    participanteFormReset() {
      (this.participante = {}), (this.usuario = {});
    },
  },
  created() {
    Promise.all([
      this.fetchAllUsuarios(),
      ]).then(() => {
      this.asyncDataStatus_fetched();
    });
  },
};
</script>

<style src="./Projeto.scss" lang="scss"></style>
